var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var IntlProvider = ReactIntl.IntlProvider;
var Footer = require('../Footer/Footer');
var Header = require('../Header/Header');
var LoginActions = require('../../actions/LoginActions');
var defaultMessages = require('../../i18n/messages/default');
var createReactClass = require('create-react-class');
var PageCase = require('../PageCase/PageCase.js');
var UrlUtils = require('../../utils/urlUtils.js');
var LoginBoxWrapper = require('../LoginBoxWrapper/LoginBoxWrapper.js');
var { Input, Button } = require('metro-ui-components');
var LoginHiddenFields = require('../Login/LoginHiddenFields.js');
var PasswordField = require('../Password/PasswordField.js');
var LoginHelper = require('../../utils/loginHelper.js');
var LoginHandler = require('../Login/LoginHandler.js');
var TwoFactorAuthenticationRenderer = require('../TwoFactorAuthenticationRenderer/TwoFactorAuthenticationRenderer.js');
var AuthMethodsHandler = require('../Login/AuthMethodsHandler.js');
var ReCaptcha = require('../../utils/ReCaptcha');

var FuncUserLoginLogin = createReactClass({

    displayName: 'FuncUserLoginLogin',

    getInitialState() {
        return {
            localeId: this.props.localeId
        };
    },

    onLocalChange(localeId) {
        this.setState({ localeId: localeId });
    },

    componentDidMount: function() {
        ReCaptcha.attachRecaptchaScript(this.props.clientId, this.props.realmId);
    },

    renderFooter: function () {

        return (
            <IntlProvider
                locale={this.state.localeId}
                messages={this.props.translations}>
                <div className='fixFooterBottom'>
                    <Footer {...this.props} locale={this.state.localeId} onLocalChange={this.onLocalChange} />
                </div>
            </IntlProvider>
        )
    },

    onLogin(evt) {
       const { loginId, password, localeId} = this.state;
       evt.preventDefault();

       if (!(loginId && password)) {
           return;
       }

        if (UrlUtils.isSamlFlow()) {
            LoginActions.submitSamlLogin(loginId, password, this.props.userType, this.props.clientId, this.props.countryCode, localeId, this.props.realmId, this.props.traceId);
        } else {
            ReCaptcha.getRecaptchaToken((token) =>
                LoginActions.submitLogin(loginId, password,
                    this.props.userType, this.props.clientId, this.props.responseType, this.props.countryCode, localeId,
                    this.props.realmId, this.props.accountId, this.props.redirectUrl, this.props.state, this.props.prompt, this.props.nonce, this.props.scope,
                    this.props.traceId, this.props.codeChallenge, this.props.codeChallengeMethod, token)
            );
        }
    },

    onLoginIdChange(e, value) {
        this.setState({ loginId: value });
    },

    onPasswordChange(password) {
        this.setState({ password: password });
    },

    renderTOTPForm() {
        return (
          <TwoFactorAuthenticationRenderer
            {... this.props}
            phone={this.state.phone}
            emailId={this.state.emailId}
            login={this.state.loginId}
            idToken={this.state.idToken}
            twoFaAuthMethod= {this.state.showTOTPControl}
            authMethodDeviceName= {this.state.authMethodDeviceName}
            userMFAMethods= {this.state.userMFAMethods}/>
        );
    },

    setLoginState(value) {
        this.setState(value)
    },

    renderLogin() {
        var props = this.props;
        var renderNewInput = false; // TODO : GET valueof renderNewInput from props depending on countrycode and userType
        const label = this.props.intl.formatMessage(defaultMessages['userName']);
        const loginButtonText = this.props.intl.formatMessage(defaultMessages['loginBtnTxt']);

        return (
            <LoginBoxWrapper>
                <div>
                    <form id="authForm" noValidate="novalidate" onSubmit={this.onLogin} autoComplete="off" >
                        <Input
                            id="user_id"
                            type="email"
                            key="user_id"
                            name="user_id"
                            autoComplete="off"
                            label={label}
                            required={true}
                            hasWarning={this.state.loginError ? true : false}
                            value={this.state.loginId}
                            onChange={this.onLoginIdChange.bind(this)}
                            onKeyUp={this.onLoginIdChange.bind(this)}
                            onKeyDown={this.onLoginIdChange.bind(this)}
                            autoFocus={true}
                        />
                        <PasswordField
                            {... this.props}
                            onPasswordChange={this.onPasswordChange} />
                        <LoginHiddenFields {... this.props} />
                        <Button
                            id="submit"
                            type="submit"
                            value="submit"
                            kind="primaryRaised"
                            size="large"
                            className="primary-button"
                            disabled={!(this.state.loginId && this.state.password)}>
                            {loginButtonText}
                        </Button>
                    </form>
                </div>
            </LoginBoxWrapper>
        );

    },

    renderContent: function () {
        let props = this.props;
        let bodyHeader = LoginHelper.getwelcomeToMetroDigitalText(props);
        let headerMessage = LoginHelper.getloginHeader(props);
        let renderedComponent = this.state.showTOTPControl ? this.renderTOTPForm() : this.renderLogin();

        return (
            <div className="portraitCenteredEmployee">
                <div className="welcomeTitle">
                    <span>
                        {bodyHeader}
                    </span>
                </div>
                <div className="employeeBoxContainer container">
                    <div className="col-md-3 col-sm-2 col-xs-0" />
                    <div className="col-md-6 col-sm-8 col-xs-12 larger-device-width">
                        <div className="row whiteContainer larger-device-width smaller-device">
                            <div className="col-xs-12 smaller-device-inside-wrap">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="form-group centreAligned loginHeader">
                                            <span>{headerMessage}</span>
                                        </ div>
                                    </div>
                                </div>
                                {renderedComponent}
                                <div className="row">
                                    <div className="forgotPasswordLink">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-2 col-xs-0" />
                </div>
                <LoginHandler {...props} localeId={this.state.localeId} setState={this.setLoginState.bind(this)} />
                <AuthMethodsHandler {...props} setState={this.setLoginState.bind(this)}/>
            </div>
        )
    },
    render: function () {
        let props = this.props;
        return (
            <PageCase
                header={<Header />}
                content={this.renderContent()}
                footer={this.renderFooter()}></PageCase>
        );
    }
});

module.exports = injectIntl(FuncUserLoginLogin);
